import React from 'react';
import { motion } from 'framer-motion';

interface TechStackCardProps {
  name: string;
  icon: React.ReactNode;
  description: string;
  color: string;
  delay?: number;
}

export const TechStackCard: React.FC<TechStackCardProps> = ({ 
  name, 
  icon, 
  description, 
  color,
  delay = 0
}) => {
  return (
    <motion.div 
      className="tech-card glass-card"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay, ease: "easeOut" }}
      whileHover={{ 
        y: -5, 
        borderColor: color,
        boxShadow: `0 10px 30px -10px ${color}40`
      }}
      style={{ '--hover-color': color } as React.CSSProperties}
    >
      <div className="tech-icon" style={{ color }}>
        {icon}
      </div>
      <div className="tech-info">
        <h4>{name}</h4>
        <p>{description}</p>
      </div>
    </motion.div>
  );
};
